import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoHeader from '../Inicio/components/LogoHeader';

function DjPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(link);
  }, []);

  const djs = [
    { 
      id: 1, 
      nombre: 'Cotera Ponce Deyvid', 
      imagen: '/img/Pfp_Defect.jpg', 
      desc: 'Especialista en música electrónica y urbana. 5 años de experiencia en eventos sociales.',
      rating: 4 
    },
    { 
      id: 2, 
      nombre: 'DJ Bambo Mix', 
      imagen: '/img/Pfp_Defect.jpg', 
      desc: 'Experto en mezclas en vivo y animación de bodas y quinceañeros.',
      rating: 4 
    },
    { 
      id: 3, 
      nombre: 'The Master Panda', 
      imagen: '/img/Pfp_Defect.jpg', 
      desc: 'DJ residente con amplio repertorio de música retro y actual.',
      rating: 5 
    },
  ];

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i key={i} className={i <= rating ? "fa-solid fa-star" : "fa-regular fa-star"} 
           style={{ color: '#FFD700', margin: '0 2px', fontSize: '16px' }}></i>
      );
    }
    return stars;
  };

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      
      {/* 1. LOGO HEADER */}
      <div style={{ backgroundColor: '#000' }}>
        <LogoHeader />
      </div>

      {/* 2. BANNER DE ANUNCIO (Estilo Bambo) */}
      <div 
        onClick={() => navigate('/login')}
        style={{ 
          backgroundColor: '#FFD700', 
          color: '#000', 
          padding: '12px', 
          textAlign: 'center', 
          fontWeight: 'bold',
          fontSize: '18px',
          cursor: 'pointer',
          borderBottom: '2px solid #333',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fff'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#FFD700'}
      >
        ⚡ Bono de Descuento de 10% por usuario nuevo ⚡
      </div>

      <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        
        {/* 3. IMAGEN DE CABECERA (PANDA DJ) */}
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <img 
                src="/img/bambo1.jpg" 
                alt="Nuestros DJ" 
                style={{ 
                  width: '100%', 
                  maxHeight: '380px', 
                  objectFit: 'cover', 
                  borderRadius: '15px',
                  border: '1px solid #333',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.6)'
                }} 
            />
        </div>

        <h2 style={{ 
          fontSize: '32px', 
          marginBottom: '40px', 
          fontWeight: '900', 
          textTransform: 'uppercase',
          letterSpacing: '2px',
          textAlign: 'center'
        }}>
          Nuestros <span style={{ color: '#FFD700' }}>Artistas</span>
        </h2>

        {/* 4. GRILLA DE DJs */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
          {djs.map((dj) => (
            <div key={dj.id} style={{ 
              width: '320px', 
              textAlign: 'center', 
              backgroundColor: '#111', 
              padding: '25px', 
              borderRadius: '20px',
              border: '1px solid #222',
              transition: 'all 0.3s ease',
              boxShadow: '0 5px 15px rgba(0,0,0,0.4)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.borderColor = '#FFD700';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#222';
            }}
            >
              <div style={{ 
                width: '100%', 
                height: '240px', 
                borderRadius: '15px',
                marginBottom: '20px',
                overflow: 'hidden',
                border: '1px solid #333',
                position: 'relative'
              }}>
                <img src={dj.imagen} alt={dj.nombre} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '50%',
                  background: 'linear-gradient(to top, #111, transparent)'
                }}></div>
              </div>

              <h3 style={{ margin: '10px 0', color: '#FFD700', fontSize: '20px', fontWeight: 'bold' }}>{dj.nombre}</h3>
              
              <div style={{ marginBottom: '15px' }}>
                {renderStars(dj.rating)}
              </div>

              <p style={{ fontSize: '14px', color: '#aaa', height: '60px', overflow: 'hidden', marginBottom: '25px', lineHeight: '1.4' }}>
                {dj.desc}
              </p>
              
              <button style={{ 
                width: '100%',
                padding: '12px', 
                backgroundColor: 'transparent', 
                color: '#fff', 
                border: '2px solid #fff', 
                fontWeight: 'bold',
                cursor: 'pointer',
                borderRadius: '30px',
                textTransform: 'uppercase',
                transition: '0.3s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.color = '#000';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#fff';
              }}
              >
                Seleccionar DJ
              </button>
            </div>
          ))}
        </div>

        {/* 5. BOTÓN VOLVER (Rojo Bambo) */}
        <div style={{ textAlign: 'center', marginTop: '80px' }}>
            <button 
                onClick={() => navigate('/')}
                style={{ 
                    backgroundColor: '#CC0000', 
                    color: 'white', 
                    padding: '15px 50px', 
                    border: 'none', 
                    fontWeight: 'bold', 
                    cursor: 'pointer',
                    textTransform: 'uppercase',
                    borderRadius: '5px',
                    letterSpacing: '1px',
                    boxShadow: '0 5px 15px rgba(204,0,0,0.3)'
                }}
            >
                VOLVER AL INICIO
            </button>
        </div>

        <hr style={{ marginTop: '60px', border: '0.1px solid #222' }} />
        <p style={{ color: '#444', fontSize: '11px', fontStyle: 'italic', textAlign: 'center' }}>
          * Los DJ están sujetos a disponibilidad según la fecha seleccionada en el calendario.
        </p>
      </div>
    </div>
  );
}

export default DjPage;